import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import { fontStyle } from '../../text/text-box/config';

export const SpinOptions = {
    suffix: i18n.t('厘米'),
    step: 0.1,
    allowDecimal: true,
    toFixed: 2,
    max: 100,
    min: -100,
};

const SpinStyle = {
    fontSize: '12px',
};

export enum ESizeFrom {
    LEFT_TOP = 'left-top',  // 左上角
    CENTER = 'center'  // 居中
}

export enum ELeftOrTop {
    LEFT = 'left',
    TOP = 'top',
}

// 填充方式
export const sizeTypes = [
    { key: ESizeFrom.LEFT_TOP, content: i18n.t('左上角') },
    { key: ESizeFrom.CENTER, content: i18n.t('居中') },
];

export const FORM_CONFIGS: FormConfig[] = [
    {
        name: FormItemName.HORIZONTAL_POSITION_TEXT,
        type: FormItemType.TEXT,
        value: FormItemLabelName.HORIZONTAL_POSITION,
        style: fontStyle,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.HORIZONTAL_POSITION,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SELECT,
        name: FormItemName.HORIZONTAL_FROM,
        options: {
            selectOptions: sizeTypes,
        },
    },
    {
        name: FormItemName.VERTICAL_POSITION_TEXT,
        type: FormItemType.TEXT,
        value: FormItemLabelName.VERTICAL_POSITION,
        style: fontStyle,
    },
    {
        type: FormItemType.SPIN,
        name: FormItemName.VERTICAL_POSITION,
        options: SpinOptions,
        style: SpinStyle,
        defaultValue: 0,
    },

    {
        type: FormItemType.SELECT,
        name: FormItemName.VERTICAL_FROM,
        label: FormItemLabelName.VERTICAL_POSITION,
        options: {
            selectOptions: sizeTypes,
        },
    },
];
